import React from "react";

const AtlassianLogo = () => {
    return (
        <svg className="slide" xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100" fill="none">
            <path d="M37.1922 47.5C36.8512 47.0456 36.1694 46.8181 35.6012 46.8181C35.1469 46.9319 34.6922 47.2728 34.465 47.7272L15.8286 85.1137C15.3741 85.9091 15.7149 86.9319 16.5104 87.2728C16.7377 87.3866 16.965 87.5 17.1922 87.5H43.215C43.7831 87.5 44.465 87.1591 44.6922 86.5909C50.1469 75.3409 46.7378 57.7275 37.1922 47.5Z" fill="#333333" />
            <path d="M90.4878 85.1138C90.1469 84.4319 55.4878 15.1137 54.6922 13.4092C54.465 12.9546 54.0103 12.6136 53.4422 12.5H53.3287C52.7603 12.5 52.1922 12.841 51.8512 13.4092C42.4194 28.2955 41.3969 46.25 49.0103 61.4772L61.5103 86.5909C61.7378 87.1591 62.3059 87.5 62.9878 87.5H89.0103C89.9194 87.5 90.6012 86.8181 90.6012 85.9091C90.6012 85.5681 90.6012 85.3409 90.4878 85.1138Z" fill="#333333" />
        </svg>
    )
};

export default AtlassianLogo;